import { Copy, AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription } from '@/components/ui/Alert';
import { Button } from '@/components/ui/Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/Dialog';
import { Input } from '@/components/ui/Input';
import { CreateAppTokenResponseDto } from '@/services/AppTokensService';

interface TokenCreatedModalProps {
  open: boolean;
  onOpenChange: (isOpen: boolean) => void;
  token: CreateAppTokenResponseDto;
  onCopy: () => void;
  copied: boolean;
}

export function TokenCreatedModal({
  open,
  onOpenChange,
  token,
  onCopy,
  copied,
}: TokenCreatedModalProps) {
  const { t } = useTranslation('translation', {
    keyPrefix:
      'pages.Settings.components.AppTokens.components.TokenCreatedModal',
  });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('title')}</DialogTitle>

          <DialogDescription>{t('description')}</DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <Alert className="border-amber-200 bg-amber-50">
            <AlertTriangle className="h-4 w-4 text-amber-600" />

            <AlertDescription className="text-amber-800">
              {t('warningDescription')}
            </AlertDescription>
          </Alert>

          <div className="relative">
            <Input
              value={token.token}
              readOnly
              className="pr-10 font-mono text-sm"
            />

            <Button
              variant="ghost"
              size="icon"
              className="absolute right-0 top-0 h-full"
              onClick={onCopy}
            >
              <Copy className="h-4 w-4" />
            </Button>
          </div>

          {copied && <p className="text-sm text-green-600">{t('copied')}</p>}
        </div>

        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>{t('done')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
